import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import Mutations from './mutations'
import Actions from './actions'
import Getters from './getters'

Vue.use(Vuex)
// vuex持久化
const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    reducer: state => ({
        token: state.token, // 这个就是存入localStorage的值
        loginType:state.loginType,//1 用户 2 BOSS
        logins:state.logins
    })
})
const store = new Vuex.Store({
    state: {
        token:'',
        loginType:'',
        idxs: '0',//用户端
        idx: '0',//boss端
        type: '0',//0 求职管理  1牛人推荐
        // education:'',experience:'',wage:''
        list:[],//用户端首页筛选
        lists:[],
        logins:1,
        selectNum:'',//用户端首页筛选数量
        selectNums:'',
        password:'',//用户端登录密码
        telphone:'',//用户端登录手机
        selectInfo:[],//用户首页地址
        selectInfos:[],
        searchArray:[],//用户搜索
        params:{},//企业注册信息
        companyAddress:[],
        userParams:[],//用户注册信息
        keepAliveRoute:'1'
    },
    mutations: Mutations,
    actions: Actions,
    getters: Getters,
    plugins: [vuexLocal.plugin]
})

export default store